import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import {IosAppUserService} from '../../../_services/ios-app-user.service';
import {IosAppUserModel} from '../../../_models/ios-app-user';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
    selector: 'app-edit-ios-app-user',
    templateUrl: './edit-ios-app-user.component.html',
    styleUrls: []
})

export class EditIosAppUserComponent extends DialogComponent<IosAppUserModel, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    mailExist = false;
    focusEventEmitter = new EventEmitter<boolean>();
    userId: string;
    username: string;
    email: string;

   
    constructor(dialogService: DialogService, private iosAppUserService: IosAppUserService) {
        super(dialogService);
    }

    ngOnInit() {
        console.log(this.userId);
        this.loading = true;

        this.iosAppUserService.get(this.userId).subscribe(data => {
            this.model.name = data.username;
            this.model.mail = data.email;
        }, error => {
            
        }, () => {
            this.loading = false;
        });
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    edit() {
        this.loading = true;
        this.message = '';
        this.model.id = this.userId;
        this.iosAppUserService.edit(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            }
            else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message;
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }
}




// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/ios-app-user/edit-ios-app-user/edit-ios-app-user.component.ts